import React from 'react'
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const AboutUs = () => {
    const { content } = useContentfulContext();

  return (
    <div className="my-10">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="relative mx-auto max-w-[37.5rem] text-center mb-10">
                    <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">About Us</h1>
                </div>
            </div>
            <div className="relative px-4 sm:px-6 lg:px-8">
                <div className="md:max-w-screen-sm lg:max-w-[992px] px-4 sm:px-6 lg:px-8 pb-12 md:pt-6 sm:pb-20 mx-auto">
                    <div className="grid gap-4 md:gap-8">
                        <div>
                            <p className="mb-5">{content.ABOUT_CONTENT.instruction_text.desc_1}</p>
                        </div>
                        <div>
                            <h2 className="text-lg sm:text-xl font-semibold mb-2">{content.ABOUT_CONTENT.instruction_text.sub_title_2}</h2>
                            <p className="mb-5">{content.ABOUT_CONTENT.instruction_text.desc_2}</p>
                        </div>
                    </div>
                    <div className='flex space-x-4'>
                        {
                            content.ABOUT_CONTENT.info_cards.map((item) => {
                                return <div className="max-w-[33.33%] bg-white border border-gray-200 rounded-lg shadow p-5">
                                <img className="rounded-t-lg w-24 h-24 mx-auto mb-4" src={item.image_url} alt="" />
                                <h5 className="mb-2 text-xl font-bold tracking-tight text-gray-900">{item.title}</h5>
                                <p className="mb-3 font-normal text-gray-700">{item.desc}</p>
                            </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
  )
}

export default AboutUs;